/**
 * The GA4 client and session IDs, parsed out of the cookies gtag writes.
 *
 * `_ga` is `GA1.1.<client_id>` where client_id is `<random>.<timestamp>`.
 *
 * `_ga_<stream>` holds the session. Google changed its format in 2025:
 *   GS1.1.<session_id>.<session_number>.…        (old)
 *   GS2.1.s<session_id>$o<session_number>$g1$t…  (current)
 * Only the old one used to parse, so every checkout carried a client ID and
 * no session ID, and every server-side purchase landed in GA4 as
 * (direct) / (none). Both are accepted here.
 *
 * `<stream>` is the measurement ID without its `G-` prefix. Other GA tags on
 * twig.io write their own `_ga_*` cookies to the same domain, and a session ID
 * from another property's stream is useless to ours, so pass the measurement
 * ID whenever it is known.
 */
export function parseGaIds(
  cookies: string,
  measurementId?: string
): { clientId: string | undefined; sessionId: string | undefined } {
  const stream = measurementId ? measurementId.replace(/^G-/, '') : '[A-Z0-9]+';
  return {
    clientId: cookies.match(/(?:^|;\s*)_ga=GA\d+\.\d+\.(\d+\.\d+)/)?.[1],
    sessionId: cookies.match(new RegExp(`(?:^|;\\s*)_ga_${stream}=GS\\d+\\.\\d+\\.s?(\\d+)`))?.[1],
  };
}
